import { computed, Injectable, signal } from '@angular/core';
import { AdminSectionEntry } from './admin-section-entry.model';

/**
 * Collects {@link AdminSectionEntry} values registered by feature libraries (for example copilot)
 * so the BrightNav admin UI can render a dashboard without importing those libraries directly.
 */
@Injectable({ providedIn: 'root' })
export class AdminSectionRegistryService {
  private readonly _entries = signal<AdminSectionEntry[]>([]);

  /** Registered sections sorted by {@link AdminSectionEntry.order} then title. */
  readonly entries = computed(() =>
    [...this._entries()].sort((a, b) => {
      const orderA = a.order ?? 0;
      const orderB = b.order ?? 0;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return a.title.localeCompare(b.title);
    })
  );

  /**
   * Registers or replaces a section. Duplicate `id` values overwrite the prior entry.
   *
   * @param entry Metadata surfaced on the admin home page.
   */
  register(entry: AdminSectionEntry): void {
    this._entries.update((list) => {
      const without = list.filter((e) => e.id !== entry.id);
      return [...without, entry];
    });
  }
}
